import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { sendEmail, doMfa } from '@chegg/one-auth-sdk';
import { getDeviceId } from '@chegg/fingerprint-web-sdk';
export { sendEmailWithSdk, sendMfaCode };
var env = process.env.CHEGG_ENV === 'prod' ? 'prod' : 'test';
var oobCode = '';
function sendEmailWithSdk(_x) {
  return _sendEmailWithSdk.apply(this, arguments);
}
function _sendEmailWithSdk() {
  _sendEmailWithSdk = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(token) {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return sendEmail(token);
        case 2:
          oobCode = _context.sent;
        case 3:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _sendEmailWithSdk.apply(this, arguments);
}
function sendMfaCode(_x2, _x3, _x4) {
  return _sendMfaCode.apply(this, arguments);
}
function _sendMfaCode() {
  _sendMfaCode = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(userUuid, token, code) {
    var dfid, result;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _context2.prev = 0;
          _context2.next = 3;
          return getDeviceId({
            uvn: '',
            userUuid: userUuid,
            platform: '',
            session_id: '',
            combined_uuid_uvn: '',
            hasSubscription: true,
            combined_uuid_sessionId: '',
            combined_uuid_uvn_sessionid: ''
          });
        case 3:
          result = _context2.sent;
          dfid = result.DFID;
          if (result.error && env != 'prod') {
            console.error('dfid error', result.error);
          }
          // eslint-disable-next-line no-empty
          _context2.next = 11;
          break;
        case 8:
          _context2.prev = 8;
          _context2.t0 = _context2["catch"](0);
          if (env != 'prod') {
            console.error('dfid request error', _context2.t0);
          }
        case 11:
          _context2.next = 13;
          return doMfa(token, oobCode, code, dfid);
        case 13:
          return _context2.abrupt("return", _context2.sent);
        case 14:
        case "end":
          return _context2.stop();
      }
    }, _callee2, null, [[0, 8]]);
  }));
  return _sendMfaCode.apply(this, arguments);
}